<template>
  <router-view />
</template>

<script setup>
import {onMounted, onUnmounted} from 'vue'

onMounted(() => {
  document.body.classList.add('black')
})

onUnmounted(() => {
  document.body.classList.remove('black')
})
</script>
